export interface DecodeJWTResultModel {
	dev: string[];
	iat: any;
}
